module.exports = __webpack_public_path__ + "img/icon-apple.c47d4429.svg";